import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCurrentUserInfo } from "actions/auth.action";

import { Redirect, BrowserRouter as Router } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SnackbarProvider } from "notistack";

// material core
import { MuiThemeProvider } from "@material-ui/core/styles";

// context
import { useGlobalContext } from "context/GlobalContext";

// containers
import Auth from "containers/Auth";
import AuthSync from "guards/AuthSync";

// atomic
import LinearProgress from "components/atoms/LinearProgress";
import Dialog from "components/molecules/Dialog";
import SnackBarBase from "components/molecules/SnackBar";

// themes
import themes from "themes";
import { PATH_NAME, THEMES } from "configs";
import TopBar from "layouts/MainLayout/TopBar";
// routes
import Routes from "routes/Routes";
import { Toaster } from "react-hot-toast";
import { userSelector } from "selectors/auth.selector";
import ChatIcon from "features/AMTChat/ChatIcon";

function App() {
  const dispatch = useDispatch();

  // Suppress ResizeObserver loop error
  useEffect(() => {
    const originalError = console.error;
    console.error = (...args) => {
      if (
        args[0] &&
        typeof args[0] === "string" &&
        args[0].includes("ResizeObserver loop")
      ) {
        return;
      }
      originalError.apply(console, args);
    };

    return () => {
      console.error = originalError;
    };
  }, []);

  useEffect(() => {
    dispatch(fetchCurrentUserInfo());
  }, []);
  // 0: light, 1: dark
  const { modeTheme, language } = useGlobalContext();
  const type = modeTheme === THEMES.LIGHT ? 0 : 1;

  return (
    // @ts-ignore
    <MuiThemeProvider theme={themes(type)}>
      <Router>
        <Auth>
          <SnackbarProvider
            autoHideDuration={process.env.REACT_APP_AUTO_HIDE_SNACKBAR || 3000}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            maxSnack={process.env.REACT_APP_MAX_SNACKBAR || 3}
          >
            <LinearProgress />
            <Toaster position="top-right" />
            <Dialog />
            <TopBar />
            <Routes />
            <SnackBarBase />
          </SnackbarProvider>
          <ChatIcon />
          <AuthSync />
        </Auth>
        {/* <Redirect to={PATH_NAME.LOGIN} /> */}
      </Router>
    </MuiThemeProvider>
  );
}

export default App;
